import actions from './actions';
import reducer from './reducer';
import saga from './saga';
import selectors from './selectors';

export * from './actions';

const notification = {
  name: 'notification',
  actions,
  selectors,
  __initialize: (/*configuration*/) => {},
  __reducer: reducer,
  __sagas: saga,
};

// Register module as redux aware module
if (!global.reduxModules.notification) {
  global.reduxModules.notification = notification;
}

export default notification;
